import { useSelector } from 'react-redux'

export default function useMissionInfo(queryFunction) {
  const mission = useSelector((state) => state.missionService.missions.find(queryFunction));
  return mission;
}
